import { render, staticRenderFns } from "./DocumentUploadModal.vue?vue&type=template&id=6867e389"
import script from "./DocumentUploadModal.vue?vue&type=script&lang=ts"
export * from "./DocumentUploadModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DocumentUploadModal.vue?vue&type=custom&index=0&blockType=stype&lang=scss&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports